import { useMediaQuery } from "@mui/material"
import WebApi from "./WebApi"
import MobApi from "./MobApi"
export default function API(){
    const isSmallScreen=useMediaQuery("(max-width:960px")
    return isSmallScreen ? <MobApi/> : <WebApi/>
}